import { jsx as e, jsxs as u } from "react/jsx-runtime";
import { useRef as E, useState as c } from "react";
import { useMultiStyleConfig as J, useBreakpointValue as K, useDisclosure as m, Flex as n } from "@chakra-ui/react";
import { Brand as L } from "./Brand.mjs";
import { Button as Q } from "../../forms/Button/Button.mjs";
import "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { UserMenu as W } from "./UserMenu.mjs";
import { MobileMenu as X } from "./MobileMenu.mjs";
import { CartNotificationButton as Y, BellNotificationButton as Z } from "./NotificationButtons.mjs";
import { GlobalHeaderv2PrivateContext as _, GlobalHeaderv2DevContext as $ } from "./GlobalHeaderv2Context.mjs";
const fe = ({
  bellNotificationCount: d,
  cartNotificationCount: p,
  brand: M,
  brandAs: b,
  brandUrl: v,
  brandVariant: h = "default",
  hideBellButton: g = !1,
  hideCartButton: x = !1,
  isPublic: C = !1,
  logo: B,
  mobileMenuHeader: G,
  mobileMenuBody: H,
  isSignedIn: t = !1,
  onBellButtonClick: R,
  onCartButtonClick: y,
  onSignInClick: O,
  onSignOutClick: l,
  userMenuBody: T,
  userName: i,
  ...U
}) => {
  const j = J("GlobalHeaderv2"), o = K({ base: !0, md: !1 }, { fallback: "md" }), r = E(null), [N, P] = c(0), [D, k] = c(!1), {
    isOpen: a,
    onToggle: f,
    onClose: z
  } = m(), {
    isOpen: F,
    onToggle: V,
    onClose: q
  } = m(), w = (s) => {
    l == null || l(s);
  }, A = () => {
    if (o && !a && r.current) {
      const { bottom: s } = r.current.getBoundingClientRect();
      P(s);
    }
    f();
  };
  return /* @__PURE__ */ e(
    _.Provider,
    {
      value: { isGlobalNavRegistered: D, onSignOutClick: l, setIsGlobalNavRegistered: k },
      children: /* @__PURE__ */ e(
        $.Provider,
        {
          value: {
            isMobileMenuOpen: a,
            onMobileMenuToggle: f,
            onMobileMenuClose: z,
            isUserMenuOpen: F,
            onUserMenuToggle: V,
            onUserMenuClose: q
          },
          children: /* @__PURE__ */ u(n, { sx: j.container, as: "header", ...U, ref: r, children: [
            o && /* @__PURE__ */ e(n, { flex: 1, children: /* @__PURE__ */ e(
              X,
              {
                heightOffset: N,
                isSignedIn: t,
                mobileMenuHeader: G,
                mobileMenuBody: H,
                onClick: A,
                userName: i
              }
            ) }),
            /* @__PURE__ */ e(
              L,
              {
                brandUrl: v,
                logo: B,
                brand: M,
                brandAs: b,
                brandVariant: h
              }
            ),
            !o && /* @__PURE__ */ e(n, { flex: 1 }),
            /* @__PURE__ */ u(n, { gap: 3, alignItems: "center", flex: o ? 1 : 0, justifyContent: "flex-end", children: [
              t && !x && /* @__PURE__ */ e(
                Y,
                {
                  isMobile: o,
                  cartNotificationCount: p,
                  onCartButtonClick: y
                }
              ),
              t && !g && /* @__PURE__ */ e(
                Z,
                {
                  isMobile: o,
                  bellNotificationCount: d,
                  onBellButtonClick: R
                }
              ),
              t && !o && /* @__PURE__ */ e(
                W,
                {
                  userName: i,
                  onSignOutClick: w,
                  userMenuBody: T
                }
              ),
              !t && !C && /* @__PURE__ */ e(Q, { size: o ? "md" : "sm", variant: "secondary", onClick: O, children: "Sign In" })
            ] })
          ] })
        }
      )
    }
  );
};
export {
  fe as GlobalHeaderv2
};
